
import { Course } from '../types';

export const enforcement: Course = {
  id: "enforcement",
  title: "Enforcement Orders",
  description: "What to do when she breaches the order. The C79 process.",
  icon: "👮",
  totalModules: 13,
  modules: {
    1: { id: 1, title: "Slide 1", slides: [{ title: "Slide 1", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide1.PNG" alt="Slide 1" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    2: { id: 2, title: "Slide 2", slides: [{ title: "Slide 2", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide2.PNG" alt="Slide 2" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    3: { id: 3, title: "Slide 3", slides: [{ title: "Slide 3", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide3.PNG" alt="Slide 3" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    4: { id: 4, title: "Slide 4", slides: [{ title: "Slide 4", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide4.PNG" alt="Slide 4" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    5: { id: 5, title: "Slide 5", slides: [{ title: "Slide 5", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide5.PNG" alt="Slide 5" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    6: { id: 6, title: "Slide 6", slides: [{ title: "Slide 6", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide6.PNG" alt="Slide 6" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    7: { id: 7, title: "Slide 7", slides: [{ title: "Slide 7", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide7.PNG" alt="Slide 7" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    8: { id: 8, title: "Slide 8", slides: [{ title: "Slide 8", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide8.PNG" alt="Slide 8" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    9: { id: 9, title: "Slide 9", slides: [{ title: "Slide 9", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide9.PNG" alt="Slide 9" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    10: { id: 10, title: "Slide 10", slides: [{ title: "Slide 10", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide10.PNG" alt="Slide 10" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    11: { id: 11, title: "Slide 11", slides: [{ title: "Slide 11", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide11.PNG" alt="Slide 11" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    12: { id: 12, title: "Slide 12", slides: [{ title: "Slide 12", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide12.PNG" alt="Slide 12" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] },
    13: { id: 13, title: "Slide 13", slides: [{ title: "Slide 13", content: `<div class="flex justify-center"><img src="/images/courses/enforcement/Slide13.PNG" alt="Slide 13" class="w-full h-auto max-w-3xl rounded-xl shadow-md border border-slate-200" /></div>` }] }
  },
  quiz: [
    {
        "q": "According to the provided content, what exclusively constitutes a legally actionable breach of a family court order?",
        "o": [
            "When a parent verbally disagrees with a court order.",
            "When a parent fails to follow a Mandatory direction within an active court order.",
            "When a child expresses a preference to not follow a court order.",
            "When a parent misses any scheduled event, regardless of a court order."
        ],
        "a": 1
    },
    {
        "q": "In the context of enforcing a family court order, on whom does the burden of proof rest regarding a valid excuse for a breach?",
        "o": [
            "The person applying for the enforcement.",
            "The court judge.",
            "The person who breached the order (the Respondent).",
            "The child involved in the order."
        ],
        "a": 2
    },
    {
        "q": "Which of the following is explicitly stated as an invalid excuse for breaching a family court order?",
        "o": [
            "A genuine medical crisis.",
            "An unavoidable accident.",
            "The child was tired or didn't want to go.",
            "A sudden, unforeseen emergency."
        ],
        "a": 2
    },
    {
        "q": "What is the mandatory form required for mobilizing a formal application to enforce a family court order?",
        "o": [
            "Form A21",
            "Form C79",
            "Form E34",
            "Form B12"
        ],
        "a": 1
    },
    {
        "q": "Which of the following is considered the 'ultimate judicial sanction' and Tier 3 in the court's enforcement arsenal for extreme cases of non-compliance?",
        "o": [
            "Unpaid Work Orders (Community Service)",
            "Financial Compensation",
            "Transfer of Residency",
            "A verbal warning from the judge"
        ],
        "a": 2
    }
]
};
